import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  disableAnalytics,
  enableAnalytics,
  readAnalyticsConsent,
  saveAnalyticsConsent,
  trackPageView,
} from "../analytics/ga4";

const GRANTED = "granted";
const DENIED = "denied";

export default function AnalyticsConsent() {
  const location = useLocation();
  const [consent, setConsent] = useState(() => readAnalyticsConsent());
  const [preferencesOpen, setPreferencesOpen] = useState(() => readAnalyticsConsent() === null);

  useEffect(() => {
    if (consent === GRANTED) {
      enableAnalytics();
    } else if (consent === DENIED) {
      disableAnalytics();
    }
  }, [consent]);

  useEffect(() => {
    if (consent === GRANTED) {
      trackPageView(`${location.pathname}${location.search}${location.hash}`);
    }
  }, [consent, location.hash, location.pathname, location.search]);

  const chooseConsent = (value) => {
    saveAnalyticsConsent(value);
    setConsent(value);
    setPreferencesOpen(false);
  };

  if (!preferencesOpen) {
    return (
      <button
        type="button"
        onClick={() => setPreferencesOpen(true)}
        className="fixed bottom-3 left-3 z-[100] rounded-full border border-white/20 bg-slate-950/90 px-3 py-2 text-xs font-semibold text-slate-200 shadow-lg backdrop-blur transition hover:border-cyan-400/60 hover:text-white focus:outline-none focus:ring-2 focus:ring-cyan-400"
        aria-label="Άνοιγμα προτιμήσεων cookies"
      >
        Προτιμήσεις cookies
      </button>
    );
  }

  return (
    <div
      className="fixed inset-x-3 bottom-3 z-[100] mx-auto max-w-3xl rounded-2xl border border-cyan-400/25 bg-slate-950/95 p-5 text-slate-100 shadow-2xl backdrop-blur md:bottom-5 md:p-6"
      role="dialog"
      aria-modal="false"
      aria-labelledby="analytics-consent-title"
    >
      <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
        <div className="max-w-2xl">
          <h2 id="analytics-consent-title" className="text-base font-bold text-white md:text-lg">
            Προαιρετικά analytics
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-slate-300">
            Με τη συγκατάθεσή σας χρησιμοποιούμε Google Analytics 4 για ανώνυμες στατιστικές
            επισκεψιμότητας και βελτίωση της ιστοσελίδας. Δεν ενεργοποιούμε διαφημιστική
            εξατομίκευση. Μπορείτε να αλλάξετε την επιλογή σας οποτεδήποτε. {" "}
            <Link to="/privacy" className="font-semibold text-cyan-300 underline underline-offset-2 hover:text-cyan-200">
              Πολιτική Απορρήτου
            </Link>
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row md:flex-col">
          <button
            type="button"
            onClick={() => chooseConsent(GRANTED)}
            className="rounded-xl bg-cyan-400 px-4 py-2.5 text-sm font-bold text-slate-950 transition hover:bg-cyan-300 focus:outline-none focus:ring-2 focus:ring-cyan-200"
          >
            Αποδοχή analytics
          </button>
          <button
            type="button"
            onClick={() => chooseConsent(DENIED)}
            className="rounded-xl border border-white/20 px-4 py-2.5 text-sm font-semibold text-slate-200 transition hover:border-white/40 hover:text-white focus:outline-none focus:ring-2 focus:ring-slate-400"
          >
            Μόνο απαραίτητα
          </button>
        </div>
      </div>
    </div>
  );
}

